import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ButtonClean = styled.button`
  color: ${({ theme }) => theme.button.primary};
  font-size: 14px;
  font-weight: 500;
  border: none;
  background: none;
  width: 55px;
  height: 25px;
  &:hover {
    text-decoration: underline;
    transform: translateY(-1px);
    cursor: pointer;
  }
  margin-right: 15px;
`;

export const ButtonFilter = styled.button`
  color: ${({ theme }) => theme.button.primary};
  font-size: 14px;
  font-weight: 500;
  border: none;
  background: none;
  width: 55px;
  height: 25px;
  &:hover {
    text-decoration: underline;
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const ContentFilters = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: 54px;
  //  border-top: 1px solid rgba(46, 46, 46, 0.1);
  z-index: 10;
`;

export const FieldsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  input::placeholder {
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.neutral.gray[2600]};
  }
  input {
    font-size: 13px;
  }
  hr {
    width: 90%;
    margin: 2px 0;
  }
  .top-hr {
    margin-bottom: 1rem;
    margin-top: 0rem;
  }

  .field-div {
    width: 90%;
    margin: 0em 1em;
    min-width: 165px;
    max-width: 165px;
    @media only screen and (max-width: 580px) {
      margin: 1em;
    }
  }

  .field-div.secondary {
    border-top: 1px solid rgba(46, 46, 46, 0.1);
    margin: 1.5px 0;
  }

  .bottom-hr {
    margin-top: 1rem;
    border-top: none;
    visibility: hidden;
  }
`;
export const FieldHeader = styled.div`
  margin: 10px 0;
  label {
    font-weight: 600;
  }
  svg {
    float: right;
  }
`;

export const ExpandedContainer = styled.div`
  margin-bottom: ${({ isVisible }) => (isVisible ? "1rem" : "0")};
  visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
  height: ${({ isVisible }) => (isVisible ? "auto" : "0")};

  label {
    color: ${({ theme }) => theme.neutral.gray[2200]};
    font-size: 12px;
  }
  input {
    font-size: 13px;
  }
  input::placeholder {
    font-size: 13px;
  }
`;
